import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function groupByCategory<T extends { category: string }>(
  items: T[],
): { category: string; items: T[] }[] {
  const groups: { category: string; items: T[] }[] = []
  const seen = new Map<string, T[]>()
  for (const item of items) {
    const existing = seen.get(item.category)
    if (existing) {
      existing.push(item)
    } else {
      const arr = [item]
      seen.set(item.category, arr)
      groups.push({ category: item.category, items: arr })
    }
  }
  return groups
}
